/**
 * Signup scripts
 *
 * @copyright 2018 Linguistica 360
 */

import '../libs/jquery.crs.js'; // countries

import { Script, injector } from '../shared/injector.js';

import $ from 'jquery';
import MicroModal from 'micromodal';


injector.injectClass(class extends Script {
    onLoad() {
        const html = $('.alert-email').html();
        if (html && html.includes('create a new account.')) {
            MicroModal.show('modal_login');
            $('#username').val($('#form_email_input').val());

            const text = 'Account with that email already exists!';

            const $div = $('<div class="alert alert-danger">');
            $div.append(`<p>${text}</p>`);
            $('#modal_login_content').prepend($div);
        }
    }
}, ['signup']);
